import React from "react";
import classes from "./MemberDetails.module.css";
import constants from "../../../../globalization";
import PopupHeader from "../PopupHeader";
import FireboardUtils from "../../../../util/fireboard-util";

const MemberDetails = (props) => {
  const {
    activeItem: {
      firstName = "",
      lastName = "",
      phoneNumber = "",
      emailAddress = "",
    },
    onClose,
    iso2,
  } = props || {};

  return (
    <div className={classes.container}>
      <PopupHeader title={constants.memberDetails} onClose={onClose} />
      <div className={classes.itemsContainer}>
        <Details label={constants.firstName} value={firstName} />
        <Details label={constants.lastName} value={lastName} />
        <Details label={constants.phoneNumber} value={FireboardUtils.formattedPhoneNumber(phoneNumber, iso2)} />
        <Details label={constants.emailAddress} value={emailAddress} />
      </div>
    </div>
  );
};

export default MemberDetails;

const Details = ({ label, value }) => {
  return (
    <div className={classes.item}>
      <span className={classes.labelTextStyle}>{label}</span>
      <span className={classes.valueTextStyle}>{value}</span>
    </div>
  );
};
